import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import routes from './routes'
import store from '@state/store'
import { getSavedState, saveState } from '@src/utils/localStorage'

Vue.use(VueRouter)
Vue.use(VueMeta, {
    keyName: 'page',
})

const router = new VueRouter({
    routes,
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: 'history',
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0,
            }
        }
    },
})

router.beforeEach((to, from, next) => {
    const isLoggedIn = !!getSavedState('auth.currentUser')
    // const ability = store.getters['auth/ability']
    if (!to.meta.rule) {
        saveState(`errorType`, 404)
        return next('/error')
    }

    if (to.path === '/reset-password' && isLoggedIn) {
        store.dispatch('auth/logOut')
        return next()
    }

    // Usuário deslogado indo para rota pública
    if (!isLoggedIn && to.meta.rule === 'isPublic') {
        // console.log(1)
        return next()
    }
    // Usuário logado indo para rota pública que não seja de resetar senha, redirecionar para home
    if (
        isLoggedIn &&
        to.meta.rule === 'isPublic' &&
        !to.path.includes(`error`) &&
        to.path !== '/reset-password'
    ) {
        return next('/')
    }
    // Usuário deslogado indo para uma rota privada, ir para tela de login
    if (!isLoggedIn && to.meta.rule !== 'isPublic') {
        return next('/login')
    }
    // Usuário sem permissão para acessar essa rota
    // if (
    //     !ability.can(to.meta.rule, 'User') &&
    //     !to.path.includes(`error`) &&
    //     !to.path.includes(`choose-location`)
    // ) {
    //     return next('/error')
    // }
    next()
})

export default router
